import * as React from "react";
const SvgFiRrPlay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m20.494 7.968-9.54-7A5 5 0 0 0 3 5v14a5 5 0 0 0 7.957 4.031l9.54-7a5 5 0 0 0 0-8.064zm-1.184 6.45-9.54 7A3 3 0 0 1 5 19V5a2.95 2.95 0 0 1 1.641-2.672 2.97 2.97 0 0 1 3.129.261l9.54 7a3 3 0 0 1 0 4.836z"
    />
  </svg>
);
export default SvgFiRrPlay;
